import React from 'react';

export default function Warning(props) {
  return (
    <svg
      height="20px"
      width="20px"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs>
        <style
          dangerouslySetInnerHTML={{ __html: `.a{fill:${props.fill};}` }}
        />
      </defs>
      <g transform="translate(-704.928 -2012.226)">
        <path
          className="a"
          d="M714.928,2032.227a10,10,0,1,1,10-10A10.012,10.012,0,0,1,714.928,2032.227Zm0-18.9a8.9,8.9,0,1,0,8.9,8.9A8.911,8.911,0,0,0,714.928,2013.325Z"
        />
        <rect
          className="a"
          width="1.178"
          height="1.181"
          transform="translate(714.341 2026.362)"
        />
        <path
          className="a"
          d="M715.283,2025.18h-.709l-.236-4.725v-3.544h1.181v3.544Z"
        />
      </g>
    </svg>
  );
}
